<template>
  <div class="dashboard-container">
    <!-- 客资管理---成单客资 -->
    <div class="app-container">
      <el-card shadow="never">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="订单号">
            <el-input v-model="customerId" placeholder="请输入订单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="微信号">
            <el-input v-model="searchWx" placeholder="请输入微信号" clearable></el-input>
          </el-form-item>
          <el-form-item label="城市">
            <el-select v-model="regionName" clearable filterable placeholder="请选择城市">
              <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"  :value="item.dictType"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学生姓名">
            <el-input v-model="searchStudent" placeholder="请输入学生姓名" clearable></el-input>
          </el-form-item>
          <el-form-item label="年级">
            <el-cascader clearable v-model="grade" :options="categoryList" :props="props"></el-cascader>
          </el-form-item>
          <el-form-item label="家长电话">
            <el-input v-model="parentPhoneNumber" placeholder="请输入家长电话" clearable></el-input>
          </el-form-item>
          <el-form-item label="学生类型">
            <el-select v-model="regionNames" clearable filterable placeholder="请选择学生类型">
              <el-option v-for="item in optionsListtt" :key="item.id" :label="item.dictValue"  :value="item.dictType"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单状态">
            <el-select clearable filterable   id="teacher" class="select" v-model="orderStatuss" placeholder="请选择收款状态">
              <el-option v-for="item in orderTypes" :key="item.value" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="续费状态">
            <el-select clearable filterable   id="teacher" class="select" v-model="isRenew" placeholder="请选择续费状态">
              <el-option v-for="item in orderTypess" :key="item.value" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学生状态">
            <el-select clearable filterable   id="teacher" class="select" v-model="state" placeholder="请选择学生状态">
              <el-option v-for="item in classTypes_s" :key="item.value" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售:">
            <el-select v-model="inputAcount" filterable  clearable  placeholder="请选择销售" :filter-method="handleChangeName">
              <el-option v-for="item in optionsList" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="投流状态:">
            <el-select v-model="trafficSource" filterable clearable placeholder="请选择状态">
              <el-option label="自然流" value="1"></el-option>
              <el-option label="付费流" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="IP老师">
            <el-select clearable id="teacher" class="select" filterable   v-model="searchTeacherId" placeholder="请选择IP老师">
              <el-option v-for="teacher in teachers" :key="teacher.value" :value="teacher.value" :label="teacher.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="渠道">
            <el-select clearable id="teacher" filterable   class="select" v-model="channelType" placeholder="请选择渠道">
              <el-option v-for="teacher in DealTypeListt" :key="teacher.value" :value="teacher.value" :label="teacher.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="来源">
            <el-select v-model="searchSource" clearable filterable   placeholder="请选择客资来源">
              <el-option v-for="item in sources" :key="item.sourceId" :label="item.sourceName" :value="item.sourceId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客资来源负责人" style="margin-right: 4rem">
            <el-select v-model="searchSourcesPeople" filterable   clearable placeholder="请选择客资来源负责人">
              <el-option v-for="item in sourcesPeople" :key="item.sourcepeopleId" :label="item.sourcepeopleName"
                :value="item.sourcepeopleId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="成单时间" style="margin-right: 1.5rem">
            <el-date-picker value-format="yyyy-MM-dd" v-model="createTimess" type="daterange" clearable range-separator="至"  start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="创建时间" style="margin-right: 1.5rem">
            <el-date-picker value-format="yyyy-MM-dd" v-model="createTimesss" type="daterange" clearable range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
          </el-form-item>


          <!-- <el-form-item label="老师姓名">
            <el-select clearable id="teacher" class="select" filterable   v-model="searchTeacherId" placeholder="请选择老师">
              <el-option v-for="teacher in teachers" :key="teacher.value" :value="teacher.value" :label="teacher.label">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="收款状态">
            <el-select clearable id="teacher" filterable   class="select" v-model="orderType" placeholder="请选择收款状态">
              <el-option v-for="teacher in DealTypeList" :key="teacher.value" :value="teacher.value"
                :label="teacher.label">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="订单状态">
            <el-select clearable filterable   id="teacher" class="select" v-model="orderStatuss" placeholder="请选择收款状态">
              <el-option v-for="item in orderTypes" :key="item.value" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间" style="margin-right: 1.5rem">

            <el-date-picker value-format="yyyy-MM-dd" v-model="createTimes" type="daterange" clearable range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="客资来源">
            <el-select v-model="searchSource" clearable filterable   placeholder="请选择客资来源">
              <el-option v-for="item in sources" :key="item.sourceId" :label="item.sourceName"
                :value="item.sourceId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="客资来源负责人" style="margin-right: 4rem">
            <el-select v-model="searchSourcesPeople" filterable   clearable placeholder="请选择客资来源负责人">
              <el-option v-for="item in sourcesPeople" :key="item.sourcepeopleId" :label="item.sourcepeopleName"
                :value="item.sourcepeopleId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否线上预约" style="margin-right: 4rem">
            <el-select v-model="onlineStatus" clearable filterable   placeholder="请选择是否线上预约">
              <el-option v-for="item in onlineStatuss" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否线下预约" style="margin-right: 4rem">
            <el-select v-model="offlineStatus" filterable   clearable placeholder="请选择是否线下预约">
              <el-option v-for="item in offlineStatuss" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否续费" style="margin-right: 4rem">
            <el-select v-model="isRenew" clearable filterable   placeholder="请选择是否续费">
              <el-option v-for="item in isRenews" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="个人账号:">
            <el-select v-model="inputAcount" filterable  clearable  placeholder="请选择个人账号">
              <el-option v-for="item in optionsList" :key="item.name" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="学生状态:">
            <el-select class="select" filterable  clearable v-model="state" placeholder="请选择学生状态" style="width:100%;">
              <el-option v-for="item in classTypes_s" :key="item.value" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
          </el-form-item>



          <el-form-item label="定金时间" style="margin-right: 1.5rem">
            <el-date-picker value-format="yyyy-MM-dd" v-model="createTimess" type="daterange" clearable range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>


          <el-form-item label="全款时间" style="margin-right: 1.5rem">
            <el-date-picker value-format="yyyy-MM-dd" v-model="createTimesss" type="daterange" clearable range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="所在地域:">
            <el-select v-model="regionName" clearable filterable placeholder="请选择所在地域">
              <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
              :value="item.dictType"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="投流状态:">
            <el-select v-model="trafficSource" filterable clearable placeholder="请选择状态">
              <el-option label="自然流" value="1"></el-option>
              <el-option label="付费流" value="2"></el-option>
            </el-select>
          </el-form-item> -->



          <!-- <el-form-item label="课程类别" style="margin-right: 4rem">
            <el-select v-model="classType" clearable placeholder="请选择课程类别">
              <el-option v-for="item in classTypsArr" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="尾款付费情况">
                  <el-select v-model="customerIsallpay" clearable placeholder="请选择付费情况">
                    <el-option label="全额尾款" value="1"></el-option>
                    <el-option label="分期尾款" value="2"></el-option>
                  </el-select>
                </el-form-item> -->
          <!-- <el-form-item style="">
            <el-button @click="handleClear" icon="el-icon-close" size="small" class="btns">清除</el-button>
            <el-button type="primary" @click="handleSearch" size="small" class="btns" icon="el-icon-search">搜索</el-button>
            <el-button type="primary" icon="el-icon-download" size="small" class="btns" @click="handleDownload">导出</el-button>
          </el-form-item> -->

          <el-form-item label="收款类型">
            <el-select v-model="searchSource1" clearable filterable   placeholder="请选择收款类型">
              <el-option v-for="item in sources1" :key="item.sourceId" :label="item.sourceName" :value="item.sourceId"></el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="是否结清">
            <el-select v-model="searchSource2" clearable filterable   placeholder="请选择是否结清">
              <el-option v-for="item in sources2" :key="item.sourceId" :label="item.sourceName" :value="item.sourceId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="诊断师">
            <el-select v-model="searchSource22" clearable filterable   placeholder="请选择是否结清">
              <el-option v-for="item in sources22" :key="item.teacherId" :label="item.teacherName" :value="item.teacherId"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="规划师">
            <el-select v-model="searchSource222" clearable filterable   placeholder="请选择是否结清">
              <el-option v-for="item in sources222" :key="item.teacherId" :label="item.teacherName" :value="item.teacherId"></el-option>
            </el-select>
          </el-form-item>

        </el-form>

        <div style=" text-align: end; padding: 20px;">
            <el-button @click="handleClear" icon="el-icon-close" size="small" class="btns">清除</el-button>
            <el-button type="primary" @click="handleSearch" size="small" class="btns" icon="el-icon-search">搜索</el-button>
            <el-button type="primary" icon="el-icon-download" size="small" class="btns" @click="handleDownload">导出</el-button>
        </div>
        <!-- 查询列表 -->
        <el-table :header-cell-style="{'text-align':'center', background: '#fafafa', }" :cell-style="{'text-align':'center'}" :data="list" border height="700"  v-loading="tableLoading"  element-loading-text="加载中...">

          <el-table-column :resizable="false" prop="customerId" label="订单号"></el-table-column>
          <el-table-column :resizable="false" prop="customerWx" label="微信" align="center" width="180"></el-table-column>
          <el-table-column :resizable="false" prop="regionName" label="城市" align="center"></el-table-column>
          <el-table-column :resizable="false" prop="customerStudent" label="学生姓名"></el-table-column>
          <el-table-column :resizable="false" prop="grade" label="年级" width="150"></el-table-column>
          <el-table-column :resizable="false" prop="parentPhoneNumber" label="家长电话" width="180"></el-table-column>
          <el-table-column :resizable="false" prop="classType" label="学生类型">
            <template v-slot="scope">
                <span v-if="scope.row.classType === 1">规划</span>
                <span v-if="scope.row.classType === 2">线下</span>
                <span v-if="scope.row.classType === 3">纯补课</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="customerIsallpay" label="订单状态">
            <template v-slot="scope">
                <span v-if="scope.row.customerIsallpay === 1">已收费</span>
                <span v-else-if="scope.row.customerIsallpay === 2">待收费</span>
                <span v-else-if="scope.row.customerIsallpay === 3">已退费</span>
                <span v-else-if="scope.row.customerIsallpay === 4">已关单</span>
            </template>
          </el-table-column>

          <el-table-column :resizable="false" prop="collectionType" label="收款类型">
            <template v-slot="scope">
                <span v-if="scope.row.collectionType === 1">全款</span>
                <span v-if="scope.row.collectionType === 2">分期</span>
            </template>
          </el-table-column>

          <el-table-column :resizable="false" prop="isSettle" label="是否结清">
            <template v-slot="scope">
                <span v-if="scope.row.isSettle === 1">是</span>
                <span v-else>否</span>
            </template>
          </el-table-column>



          <el-table-column :resizable="false" prop="isRenew" label="续费状态">
            <template v-slot="scope">
                <span v-if="scope.row.isRenew === 1">是</span>
                <span v-if="scope.row.isRenew === 2">否</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="state" label="学生状态">
            <template v-slot="scope">
              <span v-if="scope.row.state === 1">在读</span>
              <span v-if="scope.row.state === 2">结业</span>
              <span v-if="scope.row.state === 3">停课</span>
              <span v-if="scope.row.state === 4">流失</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="customerAccountName" label="销售">
            <template v-slot="scope">
              <span v-if="scope.row.customerAccountName === '10015'">杨佳琪</span>
              <span v-else-if="scope.row.customerAccountName === '10014'">王威</span>
              <span v-else-if="scope.row.customerAccountName === '15201251274'">苏芮</span>
              <span v-else>{{ scope.row.customerAccountName ? scope.row.customerAccountName : scope.row.customerAccount  }}</span>
            </template>
          </el-table-column>

          <el-table-column :resizable="false" prop="diagnoseTeacherName" label="诊断师"></el-table-column>
          <el-table-column :resizable="false" prop="projectTeacherName" label="规划师"></el-table-column>

          <el-table-column :resizable="false" prop="trafficSource" label="投流状态">
            <template v-slot="scope">
              <span v-if="scope.row.trafficSource === 1">自然</span>
              <span v-if="scope.row.trafficSource === 2">付费流</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="customerTeacherid" label="IP老师">
            <template v-slot="scope">
              <span v-if="scope.row.customerTeacherid === 1">小单老师</span>
              <span v-if="scope.row.customerTeacherid === 2">大单老师</span>
              <span v-if="scope.row.customerTeacherid === 3">刘老师</span>
              <span v-if="scope.row.customerTeacherid === 4">杨老师</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="channelType" label="渠道">
            <template v-slot="scope">
              <span v-if="scope.row.channelType === 1">线上</span>
              <span v-if="scope.row.channelType === 2">线下</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="sourceName" label="来源"></el-table-column>
          <el-table-column :resizable="false" prop="sourcepeopleName" label="来源负责人"  width="120"></el-table-column>
          <el-table-column :resizable="false" prop="customerAllpaytime" width="180" label="成单时间"></el-table-column>
          <el-table-column :resizable="false" prop="diagnosisOrderDate" width="180" label="创建时间"></el-table-column>





          <!-- <el-table-column :resizable="false" label="订单状态">
            <template slot-scope="scope">
              <span>{{
                scope.row.orderStatus == 1
                ? "已成单"
                : scope.row.orderStatus == 2
                  ? "已关单"
                  : scope.row.orderStatus == null
                    ? ""
                    : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="parentPhoneNumber" label="家长电话" width="120">
          </el-table-column>
          <el-table-column prop="customerAccountName" label="个人账号" width="110" :resizable="false">
              <template slot-scope="scope">
                <span v-if="scope.row.customerAccountName === '10015'">杨佳琪</span>
                <span v-else-if="scope.row.customerAccountName === '10014'">王威</span>
                <span v-else-if="scope.row.customerAccountName === '15201251274'">苏芮</span>
                <span v-else>{{ scope.row.customerAccountName ? scope.row.customerAccountName : scope.row.customerAccount  }}</span>
              </template>
          </el-table-column>
          <el-table-column prop="trafficSource" label="投流状态" width="110" :resizable="false">
              <template slot-scope="scope">
                <span v-if="scope.row.trafficSource === 1">自然流</span>
                <span v-else-if="scope.row.trafficSource === 2">付费流</span>
              </template>
          </el-table-column>
          <el-table-column :resizable="false" label="收款状态" align="center" header-align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.orderType == 1
                ? "定金"
                : scope.row.orderType == 2
                  ? "全额"
                  : scope.row.orderType == 3
                    ? "分期"
                    : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" label="是否续费" width="80" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isRenew == 1">是</span>
              <span v-if="scope.row.isRenew == 2">否</span>
            </template>
          </el-table-column>
          <el-table-column label="老师" :resizable="false">
            <template slot-scope="scope">
              <span>{{
                scope.row.customerTeacherid == 1
                ? "小单老师"
                : scope.row.customerTeacherid == 2
                  ? "大单老师"
                  : scope.row.customerTeacherid == 3
                    ? "刘老师"
                    : scope.row.customerTeacherid == 4
                      ? "杨老师"
                      : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" label="是否线上预约" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.onlineStatus == 1 ? "是" : "否" }}</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" label="是否线下预约" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.offlineStatus == 1 ? "是" : "否" }}</span>
            </template>
          </el-table-column>

          <el-table-column label="学生状态">
            <template slot-scope="scope">
              <span v-if="scope.row.state === 1">在读</span>
              <span v-if="scope.row.state === 2">结业</span>
              <span v-if="scope.row.state === 3">停课</span>
              <span v-if="scope.row.state === 4">流失</span>
            </template>
          </el-table-column>

          <el-table-column :resizable="false" prop="sourcepeopleName" label="来源负责人" width="100"></el-table-column>
          <el-table-column :resizable="false" prop="sourceName" label="客资来源">
          </el-table-column>
          <el-table-column :resizable="false" prop="orderDate" label="成单时间" width="180px"> </el-table-column>
          <el-table-column :resizable="false" prop="createTime" label="创建时间" width="180px"> </el-table-column> -->

          <el-table-column header-align="center" label="操作" width="100px">
            <template v-slot="scope">
              <el-button type="text"  @click="edit(scope.row.customerId,scope.row.statusId)" :disabled="scope.row.isUpdate === 1">编辑</el-button>
              <!-- <el-button type="text"  @click="edit(scope.row.customerId)" >编辑</el-button> -->

              <el-button type="text" @click="detail(scope.row.customerId,scope.row.statusId)">详情</el-button>
              <!-- <el-button type="text" @click="deleteCustomer(scope.row.customerId)"> 删除 </el-button> -->
              <!-- <el-button type="text" @click="details(scope.row.customerId)">绑定问卷</el-button> -->
            </template>
          </el-table-column>
        </el-table>

        <!-- 图片弹层 -->
        <el-dialog :visible="previewDialogVisible" width="60%" class="custom-dialog">
          <img :src="previewImageUrl" style="max-width: 100%; max-height: 100%" />
        </el-dialog>
        <!--         分页 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="requestParameters.currentpage" :page-size="requestParameters.pagesize"
          layout="prev, pager, next,sizes, jumper" :total="total">
        </el-pagination>
        <!--        成单编辑弹窗-->
        <order-update ref="orderUpdate" @refreshOrder="refreshOrder"  CustomerFundingType="成单"></order-update>
        <!--        成单客资详情页面-->
        <order-detail ref="orderDetail"></order-detail>
      </el-card>
    </div>


    <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" title="绑定问卷"  :visible="showDing" :before-close="closeEditDialogs" width="33%">

      <div>
        <div style="margin-bottom: 10px;">绑定问卷: 测试问卷</div>
        <div>绑定提交人: 测试提交人</div>
      </div>

      <div  class="dialog-footer" style="text-align: end;">
        <div style="text-align: end;">
          <el-button size="small" @click="showDing = false">取 消</el-button>
          <el-button size="small" type="primary" @click="handleBinding">确 定</el-button>
        </div>
      </div>
    </el-dialog>


    <newModesCustomerFundingDetail v-if="isnewModesCustomerFundingDetail" ref="newModesCustomerFundingDetail" @newModesCustomerFundingDetailEvent="newModesCustomerFundingDetailEvent" typeCustomerFunding="成单" isUrView="/orderCustomer/updateOrder"></newModesCustomerFundingDetail>


  </div>
</template>
<script>
import apiBaseUrl from "../../config/api";
import axios from "axios";
// import CustomerUpdOrDet from './components/CustomerUpdOrDet.vue';
import OrderUpdate from "./OrderUpdate.vue";
import OrderDetail from "./OrderDetail.vue";
import newModesCustomerFundingDetail from "./newModesCustomerFundingDetail.vue";
export default {
  components: {
    OrderDetail,
    OrderUpdate, //成单编辑
    newModesCustomerFundingDetail,
  },
  data () {
    return {
      searchSource22:'',
      searchSource222:'',
      sources22:[],
      sources222:[],
      isnewModesCustomerFundingDetail: false,
      tableLoading: false,
      trafficSource:'',
      inputAcount:"",
      optionsList:[ ],
      categoryList: [],
      props: {
        label: "categoryName",
        children: "children",
        value: "id"
      },
      grade:[],
      classTypsArr: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],
      classTypes_s: [{ value: 1, label: '在读' }, { value: 2, label: '结业' }, { value: 3, label: '停课' },{ value: 4, label: '流失' }],
      state: "",
      classType: '',
      customerId: "",//订单号
      isRenew: "",
      regionNames: "",
      offlineStatus: "",
      onlineStatus: "",
      orderStatuss: "",//订单状态
      orderStatussss:'',
      customerPaytime: "",//付款时间
      offlineStatuss: [
        {
          value: 1,
          label: '是'
        }, {
          value: 2,
          label: '否'
        },
      ],
      onlineStatuss: [
        {
          value: 1,
          label: '是'
        }, {
          value: 2,
          label: '否'
        },
      ],
      isRenews: [
        {
          value: 1,
          label: '是'
        }, {
          value: 2,
          label: '否'
        },
      ],
      orderTypes: [
      {
          value: 2,
          label: '待收费'
        },
        {
          value: 1,
          label: '已收费'
        }, 
        {
          value: 3,
          label: '已退费'
        },
        {
          value: 4,
          label: '已关单'
        },
     
      ],
      orderTypess: [
        {
          value: 1,
          label: '是'
        }, {
          value: 2,
          label: '否'
        },

      ],
      channelType:'',
      DealTypeListt: [
        {
          value: 1,
          label: "线上",
        },
        {
          value: 2,
          label: "线下",
        },
        {
          value: 3,
          label: "转介绍",
        },

      ],
      DealTypeList: [
        {
          value: 1,
          label: "定金",
        },
        {
          value: 2,
          label: "全额",
        },
        {
          value: 3,
          label: "分期",
        },
      ],
      teachers: [
        {
          value: 1,
          label: "小单老师",
        },
        {
          value: 2,
          label: "大单老师",
        },
        {
          value: 3,
          label: "刘老师",
        },
        {
          value: 4,
          label: "杨老师",
        },
      ], //；老师
      customerIsallpay: "",//尾款付费情况
      sources: [], //客资来源列表

      sources1: [
        {
          sourceId: 1,
          sourceName: "全款"
        },
        {
          sourceId: 2,
          sourceName: "分期"
        },
      ], 
      sources2: [
        {
          sourceId: 1,
          sourceName: "是"
        },
        {
          sourceId: 0,
          sourceName: "否"
        },
      ], 

      searchSource1: "", 
      searchSource2: "", 

      sourcesPeople: [], //客资来源负责人列表
      list: [],
      address: "",
      total: 0, //总条数
      url: "",
      searchWx: "", // 输入的微信号
      searchStudent: "", //输入的学生姓名
      searchTeacherId: "", //选择的老师姓名
      orderType: "", // 请选择状态
      createTimes: [], // 创建时间
      createTimess: [], // 创建时间
      createTimesss: [], // 创建时间
      paymentTime: "", // 付款时间
      searchSourcesPeople: "", //选择的来源负责人
      searchAdd: "", //选择添加方式
      selectedState: "",
      searchSource: "", //选择来源
      stateList: [],
      d: [],
      studentName: "", // 保存学生姓名的变量
      deleteCustomerId: null,
      searchKeyword: "",
      requestParameters: {
        pagesize: 10, //每页多少条
        currentpage: 1, //当前显示页码
      },
      showEdit: false, // 控制弹层显示/隐藏的变量
      srcList: [], // 预览图像的原始链接列表
      previewImageUrl: "", // 当前预览图像的链接
      previewDialogVisible: false, // 大图预览对话框是否可见
      regionName:"",
      optionsListt:[
        {dictValue:"北京", dictType:1 },
        {dictValue:"深圳", dictType:2 },
      ],

      showDing:false,

      optionsListtt:[
        {dictValue:"规划", dictType:1 },
        {dictValue:"线下", dictType:2 },
        {dictValue:"纯补课", dictType:3 },
      ],
      parentPhoneNumber:"",


    };
  },
  created () {
    this.getList();
    this.getDataSourse();
    this.getDataSoursePeople();
    this.getcityOptions()
  },
  mounted () {
    this.optionsList = JSON.parse(sessionStorage.getItem('customersaleObj1'))

    this.sources222 = JSON.parse(sessionStorage.getItem('projectTeacherFindList'))
    this.sources22 = JSON.parse(sessionStorage.getItem('diagnoseTeacherFindList'))
    

    axios.get(`${apiBaseUrl}/category/list`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
      this.categoryList = res.data.data;
    }).catch(error => {
      this.$message({
        message: "获取课程列表失败",
        type: "error"
      });
    })

  },
  methods: {

     handleChangeName(value) {
        if (value) {
          axios.post(`${apiBaseUrl}/saleWeight/getSaleList`, { saleName: value },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
            if (res.data.code == 200) {
              let datas = res.data.data.map(fore => {
                  fore.id = fore.telephone
                  fore.saleId = fore.saleId
                  fore.label = fore.saleName 
                  return fore
              })
              this.optionsList = datas
            }else{
              this.optionsList = JSON.parse(sessionStorage.getItem('customersaleObj1'))
            }
          })
        } else {
          this.optionsList = JSON.parse(sessionStorage.getItem('customersaleObj1'))
        }
    },

    getcityOptions(){
      axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,
      { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
      }).then((res)=>{ this.optionsListt = res.data.data})
    },

    handleBinding(){
      this.$confirm('绑定后，将更新学生相关信息，是否确认进行绑定?', '提示', {  confirmButtonText: '确定',  cancelButtonText: '取消',  type: 'warning'}).then(() => {
        this.$notify({title: '成功', message: '绑定成功~', type: 'success'  })
        // this.$notify.error({ title: '错误',message: '绑定失败~' })
        this.showDing = false
      })
    },
    closeEditDialogs(){
      this.showDing = false
    },
    details(){
      this.showDing = true
    },
    //查询列表
    getList () {
      const data = {
        // classType: this.classType,
        customerId: this.customerId,
        isRenew: this.isRenew,
        offlineStatus: this.offlineStatus,
        onlineStatus: this.onlineStatus,
        customerIsallpay: this.customerIsallpay,
        customerPaytime: this.customerPaytime,
        page: this.requestParameters.currentpage,
        limit: this.requestParameters.pagesize,
        studentName: this.searchStudent, //要查询的学生姓名
        teacherId: this.searchTeacherId,
        customerAccount: "",
        customerWx: this.searchWx, //要查询的微信号
        searchSource: this.searchSource, //来源
        searchSourcesPeople: this.searchSourcesPeople,
        customerType: this.searchType,
        type: 2,
        orderType: this.orderType,
        createTimes: this.createTimes,
        paymentTime: this.paymentTime,
        orderStatus: this.orderStatuss,
        account:this.inputAcount,
        state:this.state,
        // startPayTime:this.createTimess.length > 0 ? this.createTimess[0] : '',
        // endPayTime:this.createTimess.length > 0 ? this.createTimess[1] : '',

        startPayTime: '',
        endPayTime: '',

        startAllpayTime:this.createTimess.length > 0 ? this.createTimess[0] : '',
        endAllpayTime:this.createTimess.length > 0 ? this.createTimess[1] : '',
        regionName:this.regionName || localStorage.getItem('cityTepy'),
        trafficSource:this.trafficSource,


        classType: this.regionNames,
        gradeList: this.grade.lenght > 0 ? this.grade : [],
        parentPhoneNumber: this.parentPhoneNumber,
        channelType: this.channelType,
        orderStartTime:this.createTimesss.length > 0 ? this.createTimesss[0] : '',
        orderEndTime:this.createTimesss.length > 0 ? this.createTimesss[1] : '',
        customerIsallpay: this.orderStatuss,

        collectionType: this.searchSource1,
        isSettle: this.searchSource2,



        projectTeacherId: this.searchSource222,
        diagnoseTeacherId: this.searchSource22,


      };
      //点击客资管理显示您好，xx老师
      let admin = window.localStorage.getItem("admin");
      if (admin != null) {
        data.customerAccount = JSON.parse(admin).adminNo;
      } else {
        let teacher = window.localStorage.getItem("teacher");
        if (teacher != null) {
          data.customerAccount = JSON.parse(teacher).adminNo;
        }
      }

      this.tableLoading = true

      // axios.post(`${apiBaseUrl}/orderCustomer/list`, data,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then((response) => {
      axios.post(`${apiBaseUrl}/orderCustomer/listOrder`, data,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then((response) => {
        this.tableLoading = false
        if(response.data.code === -1){
            this.$message({ message: response.data.message ,type: 'error' })
            this.list = [];
            this.total = 0;
        }else{
            this.$message({ message: response.data.message ,type: 'success' })
            this.list = response.data.data.records;
            this.total = response.data.data.total; // 更新总条数
       }
      }).catch((error) => {
          this.tableLoading = false
          this.$message({ message: error, type: 'error' })
      })
    },
    //客资来源
    getDataSourse () {
      axios
        .get(`${apiBaseUrl}/customerinformation/sourcelist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then((response) => {
          this.sources = response.data.data.list;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //客资来源负责人
    getDataSoursePeople () {
      axios
        .get(`${apiBaseUrl}/customerinformation/sourcepeoplelist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then((response) => {
          this.sourcesPeople = response.data.data.list;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //查询状态
    handleStateChange (row) {
      const { customerId, customerState } = row; // 获取当前行的 ID 和选中的值
      axios
        .put(`${apiBaseUrl}/customerinformation/customerstateupdate`, {
          customerId: customerId,
          customerState: customerState,
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((response) => {
          console.log(response);
          // 更新数据成功后，进行相应的操作
          this.stateList = response.data.data;
          if (response.data.code === 200) {
            this.$message({
              message: "客资状态保存成功",
              type: "success",
              duration: 1000,
            });
            this.getList();
          } else {
            //失败
            this.$message({
              error: "客资状态未保存",
              type: "error",
              duration: 1000,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //添加方式：主动/被动
    handleAddChange (row) {
      const { customerId, customerIsactive } = row; // 获取当前行的 ID 和选中的值
      axios
        .put(`${apiBaseUrl}/customerinformation/customerisactiveupdate`, {
          customerId: customerId,
          customerIsactive: customerIsactive,
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((response) => {
          console.log(response);
          // 更新数据成功后，进行相应的操作
          this.addList = response.data.data;
          if (response.data.code === 200) {
            this.$message({
              message: "添加方式保存成功",
              type: "success",
              duration: 1000,
            });
            this.getList();
          } else {
            //失败
            this.$message({
              error: "添加方式保存未保存",
              type: "error",
              duration: 1000,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    resetSuccesType (customer) {
      customer.type = 1;
    },

    //删除
    deleteCustomer (customerId) {
      this.$confirm("确定删除该条客资信息吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(
              `${apiBaseUrl}/customerinformation/customerdelete/${customerId}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }
            )
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                this.$message.success("删除成功");
                this.getList();
              } else {
                //失败
                this.$message.error("删除失败");
              }
            })
            .catch((error) => {
              console.log(error);
              this.$message.error("删除失败");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //图片预览
    handlePreview (url) {
      if (!this.srcList.includes(url)) {
        this.srcList.push(url);
      }
      this.previewImageUrl = url;
      this.previewDialogVisible = true;
    },
    //分页
    handleSizeChange (pageSize) {
      this.requestParameters.pagesize = pageSize;
      if (this.requestParameters.page === 1) {
      }
      this.getList(this.requestParameters);
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.requestParameters.currentpage = newPage;
      this.getList();
    },
    //清除kkkk
    handleClear () {
      this.searchSource1 = "";
      this.searchSource2 = "";
      this.inputAcount = ""
      this.customerId = ""

      this.searchSource22 = ""
      this.searchSource222 = ""


      this.isRenew = "",
      this.state = ""
      this.offlineStatus = "",
      this.onlineStatus = "",
      this.orderType = ''
      this.orderStatuss = '',
      this.createTimes = [],
      this.createTimess = [],
      this.createTimesss = [],
      this.customerIsallpay = "";
      this.searchWx = ""; // 清除查询内容
      this.searchStatus = ""; // 清除状态
      this.searchType = ""; // 清除类型
      this.searchStudent = ""; //学生姓名
      this.searchSourcesPeople = ""; //来源负责人
      this.searchSource = ""; //选择来源
      this.searchTeacherId = ""; //老师姓名
      this.regionName = ''
      this.trafficSource = ''
      this.regionNames = ''
      this.grade = []
      this.parentPhoneNumber = ''
      this.channelType = ''
      this.getList(); //重新获取列表
    },
    // 搜索
    handleSearch () {
      this.requestParameters.currentpage = 1;
      this.getList();
    },
    //修改学生弹窗
    showEditDialog () {
      this.edit(); // 在打开编辑弹层时调用获取数据的方法
      this.showEdit = true;
    },
    closeEditDialog () {
      this.showEdit = false;
    },
    // 编辑表单
    saveEditForm () {
      // 保存编辑表单的逻辑
      // 将编辑后的数据提交给后端 API
      // ...
      axios
        .put(`${apiBaseUrl}/customerinformation/customerstudentupdate`, {
          customerStudent: this.studentName,
          customerId: this.customerId,
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: "修改成功",
              type: "success",
              duration: 1000,
            });
            this.showEdit = false;
            this.getList();
          } else {
            this.$message({ error: "修改失败", type: "error", duration: 1000 });
          }
        })
        .catch(
          (error) =>
            function () {
              this.$message({
                error: "修改失败",
                type: "error",
                duration: 1000,
              });
            }
        );
    },
    refreshOrder () {
      this.getList();
    },

    newModesCustomerFundingDetailEvent(){
      this.isnewModesCustomerFundingDetail = false
      this.getList()
    },
    edit (customerId,statusId) {
      this.isnewModesCustomerFundingDetail = true
      this.$nextTick(() => {
        // this.$refs.orderUpdate.init(customerId);

        this.$refs.newModesCustomerFundingDetail.init(customerId,1,statusId);
      });
    },
    detail (customerId,statusId) {
      this.isnewModesCustomerFundingDetail = true
      this.$nextTick(() => {
        // this.$refs.orderDetail.init(customerId);

        this.$refs.newModesCustomerFundingDetail.init(customerId,2,statusId);

      });
    },
    //回显学生姓名并修改
    getStudent () {
      const data = {
        customerStudent: "",
        customerId: "",
      };
      axios
        .put(`${apiBaseUrl}/customerinformation/customerstudentupdate${data}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //成交状态
    handleChangeType (customer) {
      this.$confirm(
        `确定修改客资成交状态吗？<span style="color: red">成交状态只可修改一次!</span>`,
        `提示`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() => {
          this.$refs.orderUpdate.orderShow(customer);
        })
        .catch(() => {
          customer.type = 1;
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //导出客资
    handleDownload () {
      // 定义要传递的参数
      // const params = {
      //   customerStudent: "", // 姓名
      //   customerAccount: "", //账号
      //   customerWx: this.searchWx, //要查询的微信号
      //   customerState: this.searchStatus, //选择状态
      //   customerIsactive: this.searchAdd, //选择添加方式
      //   customerType: this.searchType,
      //   type: 2,
      // };
      const params = {
        customerId: this.customerId,
        isRenew: this.isRenew,
        offlineStatus: this.offlineStatus,
        onlineStatus: this.onlineStatus,
        customerIsallpay: this.customerIsallpay,
        customerPaytime: this.customerPaytime,
        page: this.requestParameters.currentpage,
        limit: this.requestParameters.pagesize,
        studentName: this.searchStudent, //要查询的学生姓名
        teacherId: this.searchTeacherId,
        customerAccount: "",
        customerWx: this.searchWx, //要查询的微信号
        searchSource: this.searchSource, //来源
        searchSourcesPeople: this.searchSourcesPeople,
        customerType: this.searchType,
        type: 2,
        orderType: this.orderType,
        createTimes: this.createTimes,
        paymentTime: this.paymentTime,
        orderStatus: this.orderStatuss,
        account:this.inputAcount,
        state:this.state,
        // startPayTime:this.createTimess.length > 0 ? this.createTimess[0] : '',
        // endPayTime:this.createTimess.length > 0 ? this.createTimess[1] : '',

        startPayTime: '',
        endPayTime: '',

        startAllpayTime:this.createTimess.length > 0 ? this.createTimess[0] : '',
        endAllpayTime:this.createTimess.length > 0 ? this.createTimess[1] : '',
        regionName:this.regionName || localStorage.getItem('cityTepy'),
        trafficSource:this.trafficSource,


        classType: this.regionNames,
        gradeList: this.grade.lenght > 0 ? this.grade : [],
        parentPhoneNumber: this.parentPhoneNumber,
        channelType: this.channelType,
        orderStartTime:this.createTimesss.length > 0 ? this.createTimesss[0] : '',
        orderEndTime:this.createTimesss.length > 0 ? this.createTimesss[1] : '',
        customerIsallpay: this.orderStatuss,

        projectTeacherId: this.searchSource222,
        diagnoseTeacherId: this.searchSource22,


      };
      //点击客资管理显示您好，xx老师
      let admin = window.localStorage.getItem("admin");
      if (admin != null) {
        params.customerAccount = JSON.parse(admin).adminNo;
      } else {
        let teacher = window.localStorage.getItem("teacher");
        if (teacher != null) {
          params.customerAccount = JSON.parse(teacher).adminNo;
        }
      }

      // params.customerAccount = this.inputAcount
      axios
        .post(
          `${apiBaseUrl}/orderCustomer/exportListOrder`,
          params,
          { responseType: "blob",
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }  // 设置responseType为'blob'以接收二进制数据
        )
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/vnd.ms-excel",
          }); // 从响应中获取Blob对象
          const downloadLink = document.createElement("a"); // 创建一个下载链接
          downloadLink.href = URL.createObjectURL(blob); // 设置下载链接的URL为Blob对象的URL
          downloadLink.download = "成单客资信息.xlsx"; // 设置下载文件的文件名
          // console.log(response);

          downloadLink.click(); // 触发下载
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //点击添加客资跳转客资收集
    addCustomer () {
      this.$router.push("/customercollect");
    },
  },
};
</script>

<style scoped >


.demo-form-inline {
  flex-wrap: wrap;
  display: flex;
}

/* .demo-form-inline .el-form-item {
  margin-right: 30px;
} */

.cor {
  border-radius: 5px;
  margin-top: 10px;
  background-color: #f4f4f5;
}

.num {
  padding: 10px;
  color: #ccc;
  font-size: 13px;
}

.el-icon-info {
  margin-right: 5px;
}



.page {
  position: fixed;
  bottom: 0;
  width: 80%;
}

.custom-dialog {
  overflow: auto;
}

.parent-container {
  position: relative;
}

.pagination-container {
  position: absolute;
  bottom: 10px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.el-dialog {
    width: 70% !important;
  }
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/CustomerFundingAll/orderFormCustomerFunding.vue